module.exports = {"title":"系統維護","content":"由於中國移動香港服務系統於2020年12月9日23:30 - 2020年12月10日07:00進行提升工程，我們暫時無法提供部份通訊服務包括：賬戶登錄、繳付賬單、儲值卡增值、國際漫遊、購買額外數據、申請增值服務、服務計劃升級及其他業務查詢服務。如有緊急查詢，請致電中國移動香港客戶服務熱線29458888，不便之處，敬請原諒。\n\n"}


//////////////////
// WEBPACK FOOTER
// ./src/locale/SystemMaintenance/zh-hk.json
// module id = Yg7y
// module chunks = 1